import { useMutation } from "@apollo/client";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { ParsedUrlQuery } from "querystring";
import { IActiveOrder, ICart, ProductItem, Collection ,ProductVariant, Product_list_elem} from "../../components/contracts/types";
import { Queries } from "../../services/queries";
import ProductView from "../../components/ProductView";

import MenuComponent from "../../components/menu";
import CatPath from "../../components/catpath";
import React, { useState, useEffect } from "react";
import User from "../../components/user";
import Head from 'next/head'

import {WEBSERVER} from "../../services/globals"




interface IParams extends ParsedUrlQuery {
  slug: string;
}

interface Props {
  product: ProductItem;
  categories: unknown;
}


interface IProductFacet {
  [key: string]: Array<string>;
}

const ProductDetailsPage: NextPage<Props> = ({ product, categories }) => {
  let mycount = 0;
//  console.log("product-item:~~~~~~~~" +  JSON.stringify(product));

const [count, setCount] = useState<number | null>(null);
    
useEffect(() => {
  async function getstartcount ()  {
    let mycount : number = -1;
    const queries = new Queries();
    mycount = await queries.getCartCount();
//        console.log("getstartcount: " + mycount);
    setCount(mycount);
  }

  getstartcount();
}, []);


  function addCart() {
    if (count)
      setCount(count + 1);
    else {
      setCount(1);
    }
}




/*
  const facets: IProductFacet = {};
  if (product.facetValues && product.facetValues.length > 0) {
    product.facetValues.forEach((values) => {
      facets[values.facet.name] = facets[values.facet.name] || [];
      facets[values.facet.name].push(values.name);
    });
  }
*/
  const meta_content : string = product.name + " " + product.description;
  const canonicalurl : string = WEBSERVER + "/items/" + product.slug;
  return (
    <div>
        <Head>
          <title>{product.name}</title>
          <meta name="description" content={meta_content}></meta>
          <link rel="canonical" href={canonicalurl} />
        </Head>

      <div className="container-fluid">
      <a href={WEBSERVER}>home</a>
      <div><MenuComponent props={categories} countx={count}></MenuComponent></div>
      <div className="breadcrums"><CatPath product={product}></CatPath></div>

      <h2>{product.name}</h2>
      <ProductView product={product} func={addCart}></ProductView>
     </div>
   </div>
  );
};

export default ProductDetailsPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const queries = new Queries();
  const resp = await queries.getProductBySlugs();
  const paths = resp.data.products.items.map((product: any) => ({
    params: { id: product.id, slug: product.slug },
  }));
  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { slug } = context.params as IParams;
//  console.log("+++++++ " + context);
  const queries = new Queries();
  const response = await queries.getProductDetailBySlug(slug);
  const categories = await queries.getCategories(); 
//  console.log("+++++++------ " + JSON.stringify(categories));
  return {
    props: {
      slug: context.params?.slug,
      product: response.data.product,
      categories: categories
    },
  };
};
